import state from './accessgroupmember.state'
import mutations from './accessgroupmember.mutations'
import actions from './accessgroupmember.actions'

export default {
  state,
  mutations,
  actions
}
